import { clsx } from 'clsx';
import { BannerTileStoryblok } from 'storyblok-types';
import { renderLink } from 'atoms/StoryBlokLink';
import { MediaQuery } from 'modules/mui/hooks';
import { IConfig, IsTitleExist, TileTypes } from './types';
import styles from './TileBanner.module.css';
import themeStyles from 'styles/theme/theme.module.css';

export const SEARCH_PARAM_NAME = 'show-banner-names';

export const getTileBannerConfig = ({
  blok,
  deviceType,
  className,
  searchParams,
}: {
  blok: BannerTileStoryblok;
  deviceType: MediaQuery;
  className?: string;
  searchParams?: URLSearchParams;
}): IConfig | null => {
  if (Boolean(blok.hide_on?.includes(deviceType.type))) {
    return null;
  }

  const WIDE_BY_DEFAULT = [TileTypes.PROMOTION, TileTypes.VIDEO];
  const {
    font_color,
    /** @todo boxShadow not using in component but using font-shadow */
    // box_shadow,
    link,
    youtubeLink,
    type,
    wide_view,
    button_text_mobile,
    button_text,
  } = blok;
  const theme = blok.theme?.[0]?.value;

  const css = Object.fromEntries(
    Object.entries({
      color: font_color?.color,
      /** @todo boxShadow not using in component but using font-shadow */
      // boxShadow: box_shadow,
    }).filter((arr) => !!arr[1]),
  );
  const buttonText = deviceType.isMobile
    ? !!button_text_mobile?.length
      ? button_text_mobile
      : button_text
    : button_text;

  const url = type === TileTypes.VIDEO ? youtubeLink || '' : renderLink(link);
  const isWideBlock =
    wide_view || WIDE_BY_DEFAULT.includes(blok.type as TileTypes);

  const classes = clsx(
    styles[`type-${blok.type}`],
    theme && themeStyles[`theme-${theme}`],
    isWideBlock && styles.wideTile,
    className,
  );

  return {
    url,
    css,
    classes,
    showName: Boolean(searchParams?.has(SEARCH_PARAM_NAME)),
    buttonText,
  };
};

export const isTitleExist: IsTitleExist = (titleData) => {
  const firstLevel = titleData?.content?.[0];
  const removeSpaces = (text?: string): string =>
    text?.replace(/\s+/g, '') || '';

  return (
    /* Check empty title without data */
    removeSpaces(firstLevel?.text)?.length > 0 ||
    /* Check empty title with <p></p> or <p> </p> */
    removeSpaces(firstLevel?.content?.[0]?.text)?.length > 0
  );
};
